module.exports = __webpack_public_path__ + "img/Fnac.15471496.jpg";